import { css } from '@emotion/css'
import { spacing } from '../../../styles'
import { colors } from '../../../themes'

const styles = {
  row: css({
    borderTop: `1px solid ${colors.catskillWhite}`,
  }),

  cell: css({
    padding: spacing.default,
  }),

  cellLink: css({
    padding: 0,
  }),

  link: css({
    display: 'flex',
    textDecoration: 'none',
    color: 'inherit',

    '&:focus': {
      outline: 'none',
    },

    '&:hover': {
      textDecoration: 'none',
    },
  }),
}

export default styles
